<template>
  <div>
    <b-alert
      :variant="alertData.variant"
      :show="dismissCountDown"
      dismissible
      fade
      class="mb-1"
      @dismiss-count-down="countDownChanged"
    >
      <div class="alert-body">
        <span><strong>{{ alertData.strongText }}</strong> {{ alertData.lightText }}</span>
      </div>
    </b-alert>

    <b-card>
      <b-button
        variant="primary"
        @click="goToCreatePage"
      >
        <feather-icon icon="PlusCircleIcon" />
        {{ $t('users.new') }}
      </b-button>
    </b-card>
    <b-card no-body>
      <b-table
        striped
        hover
        responsive
        class="position-relative"
        :items="readItems"
        :fields="fields"
      >
        <template #cell(name)="data">
          {{ data.item.name }}
        </template>
        <template #cell(email)="data">
          {{ data.item.email }}
        </template>
        <template #cell(admin)="data">
          {{ isAdmin(data.item.Roles) }}
        </template>
        <template #cell(createdAt)="data">
          {{ new Date(data.item.createdAt).toLocaleDateString() }}
        </template>
        <template #cell(action)="data">
          <b-link
            @click="deleteAlert(data.item.id)"
          >
            <feather-icon
              icon="TrashIcon"
              class="mr-50"
              size="20"
            />
          </b-link>
        </template>
      </b-table>
    </b-card>
  </div>
</template>

<script>
import {
  BCard,
  BTable,
  BButton,
  BLink,
  BAlert,
} from 'bootstrap-vue'

export default {
  components: {
    BCard,
    BTable,
    BButton,
    BLink,
    BAlert,
  },
  data() {
    return {
      items: [],
      // Alert
      dismissSecs: 4,
      dismissCountDown: 0,
      showDismissibleAlert: false,
      alertData: {
        lightText: null,
        strongText: null,
        variant: 'danger',
      },
    }
  },
  computed: {
    readItems() { return this.items },
    isAdmin() {
      return roles => {
        const isAdmin = roles.find(e => e.name === 'admin')
        if (isAdmin) return this.$t('users.isAdmin')
        return this.$t('users.notAdmin')
      }
    },
    fields() {
      return [
        { key: 'name', label: this.$t('users.table.name'), sortable: true },
        { key: 'email', label: this.$t('users.table.email'), sortable: true },
        { key: 'admin', label: this.$t('users.table.admin'), sortable: true },
        { key: 'createdAt', label: this.$t('users.table.createdAt'), sortable: true },
        { key: 'action', label: this.$t('users.table.action'), sortable: true },
      ]
    },
  },
  async created() { await this.load() },
  methods: {
    showAlert(alertProps, variant) {
      this.alertData = alertProps
      this.alertData.variant = variant
      this.dismissCountDown = this.dismissSecs
    },
    countDownChanged(dismissCountDown) {
      this.dismissCountDown = dismissCountDown
    },
    goToCreatePage() { this.$router.push({ name: 'pages-user-create' }) },
    deleteAlert(id) {
      this.$swal({
        ...this.$t('users.toast.deleteUser'),
        buttonsStyling: false,
        showDenyButton: true,
        customClass: { confirmButton: 'btn btn-danger mr-1', denyButton: 'btn btn-primary' },
      }).then((result => {
        if (!result.isConfirmed) { return }
        this.deleteUser(id)
          .then(() => {
            this.showAlert(this.$t('users.removeOkAlert.props'), 'success')
            this.load()
          }).catch(() => { this.showAlert(this.$t('users.removeErrorAlert.props'), 'danger') })
      }))
    },
    deleteUser(id) { return this.$store.dispatch('adminUser/delete', id) },
    async load() {
      this.items = await this.$store.dispatch('adminUser/index')
    },
  },
}
</script>
<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
@media (max-width: 767px){
  .small-devices-filterby{
    display: block;
  }
}
.dropdown button {
    padding: 0px;
}
.em-dropdown .dropdown-menu {
  max-height: 100px;
  overflow-y: hidden;
}
.dropdown-item{
  padding: 0 4px;
}
</style>
